
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInternationalCalls = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinejoin: "round",
  d: "M15.077 10.676h12.364m-12.363 5.818h12.363"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.79 20.024A9.778 9.778 0 0 0 28 13.818C28 8.396 23.604 4 18.182 4c-2.34 0-4.488.818-6.175 2.184",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.151 17.84c.195-1.222.304-2.585.304-4.022 0-5.277-1.466-9.554-3.273-9.554-1.808 0-3.273 4.277-3.273 9.554 0 1.43.108 2.785.3 4.002",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.61 18.252a9.017 9.017 0 0 0 4.175 4.156c.27.128.589.104.837-.064L17.3 20.56a.855.855 0 0 1 .811-.075l5.007 2.146c.35.149.559.51.513.887A5.132 5.132 0 0 1 18.54 28C10.51 28 4 21.49 4 13.46a5.132 5.132 0 0 1 4.482-5.09.852.852 0 0 1 .887.513l2.148 5.011a.855.855 0 0 1-.07.806l-1.78 2.717a.848.848 0 0 0-.057.835z",
  stroke: "#000",
  strokeLinejoin: "round"
}))));

      const __svgRaw = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\">\r\n        <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linejoin=\"round\" d=\"M15.077 10.676h12.364M15.078 16.494h12.363\"/>\r\n        <path d=\"M25.79 20.024A9.778 9.778 0 0 0 28 13.818C28 8.396 23.604 4 18.182 4c-2.34 0-4.488.818-6.175 2.184\" stroke=\"#000\"/>\r\n        <path d=\"M21.151 17.84c.195-1.222.304-2.585.304-4.022 0-5.277-1.466-9.554-3.273-9.554-1.808 0-3.273 4.277-3.273 9.554 0 1.43.108 2.785.3 4.002\" stroke=\"#000\"/>\r\n        <path d=\"M9.61 18.252a9.017 9.017 0 0 0 4.175 4.156c.27.128.589.104.837-.064L17.3 20.56a.855.855 0 0 1 .811-.075l5.007 2.146c.35.149.559.51.513.887A5.132 5.132 0 0 1 18.54 28C10.51 28 4 21.49 4 13.46a5.132 5.132 0 0 1 4.482-5.09.852.852 0 0 1 .887.513l2.148 5.011a.855.855 0 0 1-.07.806l-1.78 2.717a.848.848 0 0 0-.057.835z\" stroke=\"#000\" stroke-linejoin=\"round\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/international-calls.0c76075adfece2949acc966b2f26afe8.svg"),
        {
          React: SvgInternationalCalls,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      